// import React from 'react';
// import { Typography, Box } from '@mui/material';
// import './Header.css';

// const Header = () => {
//   return (
//     <Box className="header-container">
//       <Typography variant="body1" className="address">
//         Address : 
//       </Typography>
//       <Box className="contact-info">
//         <Typography variant="body1">
//           Tel :  | Email : | Web : 
//         </Typography>
//       </Box>
//       <Box className="divider" />
//     </Box>
//   );
// };

// export default Header;

import React from 'react';
import './Header.css';
import logo from '../../assets/logo.png';

const Header = () => {
  return (
    <div className="header-container">
      {/* Logo + Company Name in a row */}
      <div className="header-brand">
        <img src={logo} alt="Company Logo" className="header-logo" />
        <div className="company-name">Hithlaksh Software Solutions</div>
      </div>

      {/* Contact Info in one line */}
      <div className="header-contact">
        <span className="info-item">📍 19-12-1/121 Kesavayanagunta Tirupati, AP</span>
        <span className="info-item">📞 +91-7795791587</span>
        <span className="info-item">✉️ services@hithlakshsolutions.com</span>
      </div>

      <div className="divider"></div>
    </div>
  );
};

export default Header;
